import VipRecall from '~/pages/vip/pages/recall/reducers'
import Vip from '../pages/vip/pages/index/reducers'
import VipRecord from '../pages/vip/pages/record/reducers'
import VipMission from '../pages/vip/pages/mission/reducers'
import VipBenefit from '../pages/vip/pages/benefit/reducers'
import VipActivity from '../pages/vip/pages/activity/reducers'
import VipHonor from '../pages/vip/pages/honor/reducers'
import VipID from '../pages/vip/pages/id/reducers'
import VipMIB from '../pages/vip/pages/mib/reducers'

export default {
  Vip,
  VipRecord,
  VipMission,
  VipBenefit,
  VipActivity,
  VipHonor,
  VipID,
  VipRecall,
  VipMIB,
}
